import React from 'react';
import SchedulerSearch from '../SearchExecutionHistory/SchedulerSearch';
const SearchSchedulerContainer = () => {
  return (
    <div>
      <SchedulerSearch />
    </div>
  );
};

export default SearchSchedulerContainer;
